var React = require('react');

function IconBetslip (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.674 2.667c0-.734.678-1.33 1.517-1.334h7.619c.84.003 1.52.598 1.523 1.334v10.557a1 1 0 0 1-1.35.936L8 12.667 4.019 14.16a1 1 0 0 1-1.352-.937l.007-10.556zM5 6.713l2.196.638-1.461 1.955.909.644 1.309-1.99L9.305 10l.902-.666-1.44-1.92L11 6.77l-.335-1.077-2.16.78L8.578 4H7.465l.066 2.437-2.196-.794L5 6.713z","fill":"#FFA600"}));
}

IconBetslip.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconBetslip;

IconBetslip.default = IconBetslip;
